/* DEUX CENT TREIZE — V3 "Blanche"
   No dependencies. Progressive enhancement: every control works without this
   file (forms post normally, links navigate, details/summary expand).      */
(function () {
  'use strict';

  var D = window.DCT || {};
  var FOCUSABLE =
    'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), summary, [tabindex]:not([tabindex="-1"])';

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function announce(msg) {
    var region = $('[data-live-region]');
    if (region) { region.textContent = ''; setTimeout(function () { region.textContent = msg; }, 60); }
  }

  /* ---------------------------------------------------------------- Drawers */
  var Drawer = {
    open: null,
    lastFocus: null,

    show: function (id) {
      var el = document.getElementById(id);
      if (!el) return;
      if (Drawer.open) Drawer.hide(true);

      Drawer.lastFocus = document.activeElement;
      Drawer.open = el;

      el.hidden = false;
      var overlay = $('[data-overlay]');
      if (overlay) overlay.hidden = false;

      /* Flush the closed state, then open — synchronously.

         This used to sit inside requestAnimationFrame, purely to give the CSS
         transition a frame to start from. But rAF NEVER FIRES IN A BACKGROUND
         TAB, so the callback that sets [data-open] was simply never reached:
         the item landed in the bag, the body locked, and the drawer stayed
         parked off-screen with no way back. Measured on this store 2026-09-15
         with document.visibilityState === 'hidden': hidden=false, is-locked
         true, data-open absent, transform still translateX(448px).

         Reading offsetWidth forces the same style/layout flush the frame would
         have given, so the transition still runs from the closed position —
         without depending on a frame ever being painted. */
      void el.offsetWidth;
      el.setAttribute('data-open', '');
      if (overlay) overlay.setAttribute('data-open', '');

      document.body.classList.add('is-locked');
      $$('[aria-controls="' + id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });

      var first = $('[data-drawer-focus]', el) || $(FOCUSABLE, el);
      if (first) first.focus();
    },

    hide: function (immediate) {
      var el = Drawer.open;
      if (!el) return;
      var overlay = $('[data-overlay]');

      el.removeAttribute('data-open');
      if (overlay) overlay.removeAttribute('data-open');
      document.body.classList.remove('is-locked');
      $$('[aria-controls="' + el.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });

      var finish = function () {
        el.hidden = true;
        if (overlay) overlay.hidden = true;
      };
      if (immediate || matchMedia('(prefers-reduced-motion: reduce)').matches) finish();
      else setTimeout(finish, 320);

      if (Drawer.lastFocus && document.contains(Drawer.lastFocus)) Drawer.lastFocus.focus();
      Drawer.open = null;
    },

    trap: function (e) {
      if (!Drawer.open || e.key !== 'Tab') return;
      var items = $$(FOCUSABLE, Drawer.open).filter(function (n) { return n.offsetParent !== null; });
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  };

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); Drawer.show(opener.getAttribute('data-drawer-open')); return; }
    if (e.target.closest('[data-drawer-close]') || e.target.matches('[data-overlay]')) {
      e.preventDefault(); Drawer.hide();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && Drawer.open) { e.preventDefault(); Drawer.hide(); }
    Drawer.trap(e);
  });

  /* ------------------------------------------------------------------- Cart */
  function refreshCart() {
    return fetch(D.routes.cart + '?section_id=cart-drawer-content', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = $('[data-cart-content]', doc);
        var target = $('[data-cart-content]');
        if (fresh && target) target.innerHTML = fresh.innerHTML;

        var count = fresh ? fresh.getAttribute('data-cart-count') : null;
        if (count !== null) {
          // Exclude the drawer's own content container. It carries data-cart-count
          // too (that is how the count travels with the re-rendered section), so a
          // bare [data-cart-count] loop would immediately overwrite the line items
          // we just inserted with the bare digit and empty the drawer.
          $$('[data-cart-count]:not([data-cart-content])').forEach(function (n) {
            n.textContent = count;
            n.toggleAttribute('data-empty', count === '0');
          });
        }

        // The full cart page shows the same lines; keep it in sync after a
        // quantity change instead of leaving a stale list on screen.
        var pageCart = $('[data-cart-page]');
        if (pageCart) {
          fetch(D.routes.cart + '?section_id=main-cart', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
            .then(function (r) { return r.text(); })
            .then(function (html) {
              var doc = new DOMParser().parseFromString(html, 'text/html');
              var freshPage = $('[data-cart-page]', doc);
              if (freshPage) pageCart.innerHTML = freshPage.innerHTML;
            })
            .catch(function () { window.location.reload(); });
        }
      });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-add-to-cart]');
    if (!form || D.cartType !== 'drawer') return;
    e.preventDefault();

    var btn = $('[data-add-button]', form);
    var label = btn ? $('[data-add-label]', btn) : null;
    var previous = label ? label.textContent : '';
    if (btn) { btn.disabled = true; }
    if (label) label.textContent = '…';

    fetch(D.routes.cartAdd, {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.body.description || res.body.message || D.strings.cartError);
        return refreshCart().then(function () {
          Drawer.show('cart-drawer');
          announce(D.strings.addedToBag);
        });
      })
      .catch(function (err) {
        var slot = $('[data-add-error]', form);
        if (slot) { slot.textContent = err.message; slot.hidden = false; }
        announce(err.message);
      })
      .finally(function () {
        if (btn) btn.disabled = false;
        if (label) label.textContent = previous;
      });
  });

  document.addEventListener('click', function (e) {
    var ctl = e.target.closest('[data-line-change]');
    if (!ctl) return;
    e.preventDefault();
    ctl.disabled = true;
    fetch(D.routes.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: ctl.getAttribute('data-line'), quantity: ctl.getAttribute('data-line-change') })
    })
      .then(function () { return refreshCart(); })
      .then(function () { announce(D.strings.addedToBag); })
      .catch(function () { window.location = D.routes.cart; });
  });

  /* A generic [data-qty-step] handler used to sit here. It was dead — no markup
     in the theme ever carried that attribute — and it had no upper bound, so it
     would have let a customer ask for more units than a tracked variant has.
     The product page's quantity field brings its own stepper, which knows each
     variant's real ceiling; see the Quantity block in sections/main-product.liquid.
     The cart's own +/- controls post to /cart/change.js via [data-line-change]
     below and never used this. */

  /* ------------------------------------------------------------ Reveal on scroll */
  if (D.motionReveal && 'IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-in'); io.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    var startReveal = function () { $$('.reveal').forEach(function (el) { io.observe(el); }); };
    startReveal();
    document.addEventListener('shopify:section:load', startReveal);
  } else {
    $$('.reveal').forEach(function (el) { el.classList.add('is-in'); });
  }

  /* --------------------------------------------------- Sticky add-to-cart (mobile) */
  /* MEASURED 2026-09-24: this used to be an IntersectionObserver on `anchor`. On a
     fresh page load that observer can silently miss every later scroll — the real
     button scrolls clean off the top of the screen and the bar never appears, on
     any number of scrolls, because that one observer instance never delivers a
     second callback. Isolated by creating a second, throwaway IntersectionObserver
     on the very same anchor slightly later: it tracked correctly from the first
     scroll, which rules out the anchor/selector and points at that one observer
     instance. Rather than chase the timing, this now reuses the header's own
     scroll-position check just below (a plain 'scroll' listener reading
     getBoundingClientRect) — same mechanism, same file, already proven not to
     have this failure mode. */
  function initSticky() {
    var bar = $('[data-sticky-atc]');
    var anchor = $('[data-atc-anchor]');
    if (!bar || !anchor) return;
    var onScroll = function () {
      // Show the bar once the real button has scrolled fully out of view upwards.
      bar.toggleAttribute('data-visible', anchor.getBoundingClientRect().bottom < 0);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }
  initSticky();
  document.addEventListener('shopify:section:load', initSticky);

  /* ------------------------------------------------------------ Header on scroll */
  var header = $('[data-header]');
  if (header) {
    var lastY = 0;
    var onScroll = function () {
      var y = window.scrollY;
      header.toggleAttribute('data-scrolled', y > 8);
      lastY = y;
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* -------------------------------------------------------- Predictive search */
  var searchInput = $('[data-predictive-input]');
  if (searchInput && D.routes.predictiveSearch) {
    var results = $('[data-predictive-results]');
    var timer;
    searchInput.addEventListener('input', function () {
      clearTimeout(timer);
      var q = searchInput.value.trim();
      if (q.length < 2) { if (results) { results.innerHTML = ''; results.hidden = true; } return; }
      timer = setTimeout(function () {
        var url = D.routes.predictiveSearch +
          '?q=' + encodeURIComponent(q) +
          '&resources[type]=product&resources[limit]=6&section_id=predictive-search';
        fetch(url)
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var fresh = $('[data-predictive-results]', doc);
            if (results && fresh) { results.innerHTML = fresh.innerHTML; results.hidden = false; }
          })
          .catch(function () { /* the form still submits normally */ });
      }, 220);
    });
  }
})();
